import React from 'react';
import LegalPolicyPage from '../components/content/LegalPolicyPage.jsx';
import { cookiePolicyFallback } from './legalPageDefaults.js';

export default function CookiePolicyPage() {
  return <LegalPolicyPage slug="cookie-policy" fallback={cookiePolicyFallback} />;
}
